import * as React from 'react';
import type { ICommentManager } from '@src/slide/application/service/comment-manager/core/pc/comment-manager.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import type { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import type { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import type { ICTPoint2DDelta } from '@tencent/slide-sdk-model';
import { observer } from 'mobx-react';
import { Component } from 'react';
import { GroupUIEdge } from '../../../../element-types/group-element/constant';
import { ServicesContext } from '../../../context';
import SelectedElementWrapperUtil from '../../../selected-element-layer/utils';
import CommentAnchor from './comment-anchor';

interface IElementCommentBorder {
    commentManager: IDynamicService<ICommentManager>;
    elementModel: IElementBaseModel;
    scale: number;
    commentCount: number;
    anchorPosition?: ICTPoint2DDelta;
    isActive?: boolean;
    isHover?: boolean;
}

@observer
class ElementCommentBorder extends Component<IElementCommentBorder> {
    public static contextType = ServicesContext;

    public render() {
        const { elementModel, scale } = this.props;
        if (!elementModel.id || !this.props.commentCount) return null;

        let frameInfoForOuter = SelectedElementWrapperUtil.frameInfoForOuter(elementModel, false);
        let rootGroupFrame = this.getRootGroupFrame(elementModel);
        frameInfoForOuter = this.getOuterFrameInfo(elementModel, frameInfoForOuter);
        // canvas模式 对坐标进行取整操作
        frameInfoForOuter = this.canvasRectFloor(frameInfoForOuter);
        rootGroupFrame = this.canvasRectFloor(rootGroupFrame);
        const finalFrame = { ...frameInfoForOuter, ...rootGroupFrame };
        const isActiveOrHover = this.props.isHover || this.props.isActive;
        return (<div
            id={'element-comment-border'}
            style={{
                position: 'absolute',
                pointerEvents: 'none',
                top: `${finalFrame.top * scale}px`,
                left: `${finalFrame.left * scale}px`,
                width: `${finalFrame.width * scale}px`,
                height: `${finalFrame.height * scale}px`,
                transform: `${SelectedElementWrapperUtil.transformForOuter(elementModel)}`,
                outline: this.props.isActive ? '2px dashed #ffab00' : '',
            }}
        >
            <CommentAnchor
                count={this.props.commentCount}
                anchorPosition={isActiveOrHover ? this.props.anchorPosition : undefined}
                elementSize={{
                    width: finalFrame.width,
                    height: finalFrame.height,
                }}
                scale={scale}
                isActive={isActiveOrHover}
                elementId={elementModel.id}
                commentManager={this.props.commentManager}
            />
        </div>);
    }

    private isRootGroup(elementModel) {
        return elementModel.type === UIModelType.GROUP && elementModel.isRootGroup;
    }

    private getOuterFrameInfo(elementModel, frameInfoForOuter) {
        if (elementModel.type === UIModelType.TABLE) {
            if (this.context.editingStateManager.isResizing) {
                // eslint-disable-next-line no-param-reassign
                frameInfoForOuter = elementModel.getFrame?.().getFrameInfo(false);
            }
        }
        return frameInfoForOuter;
    }

    private getRootGroupFrame(elementModel) {
        const isRootGroup = this.isRootGroup(elementModel);
        let rootGroupFrame = {};
        if (isRootGroup) {
            const rect = elementModel.getFrame?.().getFrameInfo(!!elementModel.operationFrame);
            rootGroupFrame = {
                left: rect.left - GroupUIEdge,
                top: rect.top - GroupUIEdge,
                width: rect.width + (GroupUIEdge * 2),
                height: rect.height + (GroupUIEdge * 2),
            };
        }
        return rootGroupFrame;
    }

    // canvas模式下，为了与canvas坐标一致（component-wrapper进行了向下取整），需将left/top向下取整
    private canvasRectFloor(rect) {
        ['top', 'left'].forEach((prop) => {
            if (rect?.[prop]) {
                rect[prop] = Math.floor(rect[prop]);
            }
        });
        return rect;
    }
}

export default ElementCommentBorder;
